
import { clearPageLoader } from "../../Redux/Features";
import { utility } from "../../Utility";
import { Message } from "../../Utility/Services";
import { debounce } from "lodash";

const debouncedErrorMessage = debounce((status, message) => {
    Message.error(`Status: ${status || 400}`, message);
}, 1000, { leading: true, trailing: false });

export const catchAsyncErrors = (Service) => async (...args) => {
    try {
        return await Service(...args);
    } catch (exc) {
        let { message, cause: status } = exc;

        if (!window.navigator.onLine) {
            return Message.error("Please make sure you have a stable internet connection!", message);
        }

        utility.dispatch(clearPageLoader());

        debouncedErrorMessage(status || (exc.name === 'TypeError' ? 400 : 500), message);
    }
};
